export default {
  'redeemPoint.title': 'Point Redemption',
  'redeemPoint.collect_success': 'Points Collected Successfully',
  'redeemPoint.redeem_success': 'Points Deducted Successfully',
  'redeemPoint.redeem_fail': 'Points Deduction Failed',
  'redeemPoint.point_not_enough': 'Insufficient Points, Unable to Deduct',
  'redeemPoint.please_enter_quantity': 'Please Enter the Quantity of Points',
  'redeemPoint.next_step': 'Next Step',
} as Record<string, string>;
